import { VerifyTwoPlusSacc } from "./verifyTwoPlusSacc";

export default VerifyTwoPlusSacc;